export const RESOURCES_MODULE_NAME = "resources";
export const RESOURCES_VEHICLE_MODULE_NAME = "resources-vehicles";
